import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import styles from "./CustomModal.module.css";

import HorizontalLogo from "../../../../assets/images/HorizontalLogo.png";
import profilepic from "../../../../assets/images/profilepic.png"; // Default image for fallback

import { API_URL } from "../../../../api";
import UpgradeModal from "../upgradenow/upgradenow";
import { useCookies } from "../../../../hooks/useCookies";
import { useSocket } from "../../../../Context/SockerContext";
import { getProfileImageUrl } from "../../../../utils/serverUtils";
import { useAppContext } from "../../../../Context/UseContext";

const MatchCustomModal = ({ matchmodal, handleClose, MatchuserDetails }) => {
  const cookies = useCookies();
  const [showmodal, setshowmodal] = useState(false);
  const { socket } = useSocket();
  const navigate = useNavigate();
  const userId = cookies.getCookie("userId");
  const { isPremium } = useAppContext();
  const location = useLocation();

  if (!matchmodal || !MatchuserDetails) return null;

  const { withUserIdP, userDetailsP, mediaP, mediaU } = MatchuserDetails;

  // Default to profilepic if no media is available
  const user2Image =
    mediaP && mediaP[0] ? getProfileImageUrl(mediaP[0]) : profilepic;
  const user1Image =
    mediaU && mediaU[0] ? getProfileImageUrl(mediaU[0]) : profilepic;

  async function getRoom() {
    if (isPremium !== true) {
      setshowmodal(true);
      return;
    }

    try {
      const response = await fetch(`${API_URL}customer/chat/create-room`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${cookies.getCookie("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          participantId: withUserIdP,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        if (sessionStorage.getItem("conversationId")) {
          socket?.emit("leave-room", sessionStorage.getItem("conversationId"));
        }
        sessionStorage.setItem("conversationId", data.conversationId);
        navigate(`/user/chat/with/${userDetailsP.user_id}?token=${encodeURIComponent(userDetailsP.profile_token || "")}`, {
          state: {
            name: userDetailsP.first_name,
            img: user2Image,
            recepientId: userId,
            profile_token: userDetailsP.profile_token,
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
  const handleKeepBrowsing = () => {
    handleClose();
    if (location.pathname === "/user/home") {
      window.dispatchEvent(new Event("refetchProfiles"));
    } else {
      navigate("/user/home");
    }
  };

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={handleClose}>
          &times;
        </button>
        <img
          className={styles.img}
          src={HorizontalLogo}
          alt="Horizontal Logo"
        />
        <p className={styles.text}>
          It’s a <span style={{ color: "#4B164C" }}>match!</span>
        </p>

        <div className={styles.bothimg}>
          <div className={`${styles.maincontainer} ${styles.left}`}>
            <div className={styles.imgContainer}>
              <img
                src={user1Image}
                alt="User 1"
                width={270}
                height={270}
                style={{
                  borderRadius: "9999px",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>

          <div className={`${styles.maincontainer} ${styles.right}`}>
            <div className={styles.imgContainer}>
              <img
                src={user2Image}
                alt="User 2"
                width={270}
                height={270}
                style={{
                  borderRadius: "9999px",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        </div>

        <button className={styles.button} onClick={getRoom}>
          Send a message
        </button>
        <p className={styles.keepbrowsing} onClick={handleKeepBrowsing}>
          Keep browsing
        </p>
      </div>
      <UpgradeModal show={showmodal} setShow={setshowmodal} />
    </div>
  );
};

export default MatchCustomModal;
